export const convertBytesToMB = (bytes?: number | null) => {
  if (!bytes) return '0 MB'
  return `${(bytes / (1024 * 1024)).toFixed(2)} MB`
}
